import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of, concat } from 'rxjs';
import * as ReturnsActions from '../../../store/returns/returns.actions';
import { setIsLoading as setIsReturnsGridLoading } from '../../../store/returns/grid/returns.grid.actions';
import * as ShipmentsNavAction from '../../../store/shipments/nav/shipments.nav.actions';
import Global from '../../../store/global-selectors';
import { RETURNS_VIEW_ID, RETURNS_ADVANCED_SEARCH_VIEW_ID } from '../../../components/shipping-grid/views/view-id-constants';

import * as Actions from './returns.nav.actions';
import { getSelectedViewFromPathName } from '../../../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';

export const returnsViewsChanged = (action$, { getState }, { history }) =>
  action$.pipe(
    ofType(Actions.RETURNS_VIEWS_CHANGED),
    mergeMap(() => {
      const state = getState();
      const view = getSelectedViewFromPathName(history.location.pathname);
      const searchPerformed = Global.selectReturnsNavSearchPerformed(state);
      const searchData = Global.selectReturnsNavSearchData(state);
      const getReturnsAction = searchPerformed ? of(Actions.returnsSearch(searchData)) : of(ReturnsActions.getReturns());
      const observables = view.id !== RETURNS_ADVANCED_SEARCH_VIEW_ID ? [getReturnsAction] : [];
      if (view.id !== RETURNS_VIEW_ID && view.id !== RETURNS_ADVANCED_SEARCH_VIEW_ID) {
        observables.push(of(ShipmentsNavAction.shipmentsChangeView(RETURNS_VIEW_ID, false)));
      }
      return concat(of(setIsReturnsGridLoading(true)), ...observables);
    }),
  );
